// extracted by mini-css-extract-plugin
export default {"wrapper":"DateSeparator_wrapper__-YPoc","date":"DateSeparator_date__NXLSw","line":"DateSeparator_line__ONraT"};